import { render, staticRenderFns } from "./EffectTile.vue?vue&type=template&id=a16a0a70&scoped=true&"
import script from "./EffectTile.vue?vue&type=script&lang=js&"
export * from "./EffectTile.vue?vue&type=script&lang=js&"
import style0 from "./EffectTile.vue?vue&type=style&index=0&id=a16a0a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16a0a70",
  null
  
)

export default component.exports